import { gql } from '@grandvisionhq/graphql';

/**
 * This Price type is used in the deprecated variant.prices object
 */ const productPricesFragment = gql`
  fragment productPricesFragment on ProductPrices {
    originalPrice {
      currencyCode
      amount
    }
    discountedPrice {
      price {
        amount
        currencyCode
      }
      discountInformation {
        value
        name {
          locale
          value
        }
        type
        description {
          locale
          value
        }
        validity {
          validFrom
          validUntil
        }
      }
    }
  }
`;

export { productPricesFragment };
//# sourceMappingURL=productPrices.js.map
